import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import BookingRequestsPanel from "./BookingRequestsPanel";
function Bookings() {

    return (
        <>
            <SubHeader title="Booking Requests" description={"Clinic Website Booking Requests"}>

            </SubHeader>
            <div className='app-container container-xxl'>
               <BookingRequestsPanel/>
            </div>
        </>
    )
}

export default Bookings